import * as Actions from './inventory.actions';

const initialState = {
  importSummaryModalOpen: false,
  importSummary: [],
};

const actionMap = {
  [Actions.OPEN_IMPORT_SUMMARY_MODAL]: (state, action) => {
    const { importSummary } = action;
    return {
      ...state,
      importSummary,
      importSummaryModalOpen: true,
    };
  },
  [Actions.CLOSE_IMPORT_SUMMARY_MODAL]: (state) => {
    return {
      ...state,
      importSummary: [],
      importSummaryModalOpen: false,
    };
  },
};

export const reduce = (state = initialState, action = {}) => {
  const reducer = actionMap[action.type];
  if (reducer) {
    return reducer(state, action);
  }

  return state;
};

export const namespace = 'inventory';
